import styled from 'styled-components'
import { VStack } from '../../../global/styles'

export const DonationDetailsWrap = styled(VStack)`
  width: 100%;
  height: 100%;
`

export default DonationDetailsWrap;
